import Vue from 'vue'
import Router from 'vue-router'
import Contract from './views/Contract.vue'
import Faq from './views/Faq.vue'
import Home from './views/Home.vue'
import Quit from './views/Quit.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/faq',
      name: 'Faq',
      component: Faq
    },
    {
      path: '/game',
      name: 'game',
      // route level code-splitting
      // this generates a separate chunk (game.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "game" */ './views/Game.vue')
    },
    {
      path: '/quit',
      name: 'quit',
      component: Quit
    },
    {
      path: '/contract',
      name: 'contract',
      component: Contract
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
